import { createSlice } from '@reduxjs/toolkit';

const initialState: RulesState = {
    templateRespositoryId: -1,
    prevTemplateRepositoryId: -1,
    templateConfig: { templateRepositoryId: -1 }
};

const rulesSlice = createSlice({
    name: 'rules',
    initialState,
    reducers: {
        getPrevTempRepoId(state, action) {
            state.prevTemplateRepositoryId = action.payload;
        },
        getTRepositoryId(state, action) {
            state.templateRespositoryId = action.payload;
        },
        getTRepositoryConfig(state, action) {
            state.templateConfig = action.payload;
        }
    }
});

export const { getTRepositoryId, getTRepositoryConfig, getPrevTempRepoId } = rulesSlice.actions;
export default rulesSlice.reducer;
